module.exports = __webpack_public_path__ + "img/logo.4b7d3a9e.svg";